<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">{{formatType(type).title}}</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">{{formatType(type).value}}</span>
			<div class="inner-btn" @click="changeType">
				{{type=='list'?'添加数据':'返 回'}}
			</div>
		</div>
		<ListData ref="list" v-if="type==='list'" @toEdit="toEdit"></ListData>
		<AddData v-if="type==='add'" @back="back" ></AddData>
		<EditData v-if="type==='edit'" @back="back" :data_key="data_key"></EditData>
		<!-- 
		<AddData v-if="type==='add'" @back="back" ></AddData>
		 -->
	</div>
</template>

<script>
	import ListData from '../../components/data/ListData.vue'
	import AddData from '../../components/data/AddData.vue'
	import EditData from '../../components/data/EditData.vue'
	let types = {
		list: {
			title: '数据列表',
			value: 'data list'
		},
		add: {
			title: '数据操作',
			value: 'data deal'
		},
		edit: {
			title: '修改数据户',
			value: 'edit data'
		}
	}
	export default {
		components: {
			ListData,
			AddData,
			EditData
		},
		data() {
			return {
				type: 'list',
				data_key: null
			}
		},
		filters: {
			formatType(value) {
				return types[value]
			}
		},

		methods: {
			formatType(value) {
				return types[value]
			},
			changeType() {
				if (this.type === 'add' || this.type === 'edit') {
					this.type = 'list'
				} else {
					this.type ='add'
				}
				console.log(this.type)
			},
			back() {
				this.type = 'list'
				setTimeout(() => {
					this.$refs.list.search()
				}, 500)

			},
			toEdit(data_key) {
				this.data_key = data_key
				setTimeout(() => {
					this.type = 'edit'
				}, 500)
				
			}
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}

	.page .container-fluid .inner-btn {
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
	}
	.page .container-fluid .inner-btn:hover{
		background-color: #9a9a9a;
	}
</style>